// @ts-nocheck
import { Plugin } from '/home/jenkins/workspace/BUILD_NODE_IMAGE_TMP/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
